import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BMIForm from "./components/BMIForm";
import SuccessPage from "./components/sucesspage";
import "../src/global.css";
import "../src/App.css";
import Test1 from "./components/Test1";
import Loader from "./components/loader";
// import FeedbackForm from './components/test'


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<BMIForm />} />
          <Route path="/success" element={<SuccessPage />} />
          {/* <Route path="/form" element={<FeedbackForm/>}/> */}
          <Route path="/test" element={<Test1/>}/>
          {/* <Route path="/test" element={<FeedbackForm />} /> */}
          <Route path="/loader" element={<Loader/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
